import { cloneElement, isValidElement } from 'react';
import type { ReactElement } from 'react';
import { Tooltip } from '@mui/material';
import { styled } from "@mui/material/styles";
import Zoom from "@mui/material/Zoom";

const SidebarTooltip = styled(({ className, children, ...props }: any) => {
  // MUI Tooltip owns the accessible label. A native title on its direct child
  // creates a second browser tooltip and causes MUI's duplicate-title warning.
  const child = isValidElement(children)
    ? cloneElement(children as ReactElement<any>, { title: undefined })
    : children;

  return (
    <Tooltip
      arrow
      placement="right"
      TransitionComponent={Zoom}
      enterDelay={250}
      leaveDelay={80}
      PopperProps={{
        modifiers: [{ name: "offset", options: { offset: [0, 0] } }],
      }}
      classes={{ popper: className }}
      {...props}
    >
      {child}
    </Tooltip>
  );
})(({ theme }) => ({
    "& .MuiTooltip-tooltip": {
      background: theme.palette.mode === "dark" ? "#1f2937" :theme.palette.primary.main,
      color: "#fff",
      fontSize: 12,
      padding: "8px 10px",
      borderRadius: 8,
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.shadows[6],
    },
    "& .MuiTooltip-arrow": {
      color: theme.palette.mode === "dark" ? "#1f2937" :theme.palette.primary.main,
    },
  }));

export default SidebarTooltip;
